// extracted by mini-css-extract-plugin
module.exports = {"receiveCardContainer":"styles_receiveCardContainer__1TOQp","receiveCard":"styles_receiveCard__2KkpA","switchContainer":"styles_switchContainer__3EZti"};